import React, { ReactNode } from 'react';
import { Header } from '../Header/Header';
import { PartnerList } from '../Partners/PartnerList';
import { Carousel } from '../Partners/Carousel/Carousel';
import { Footer } from '../Footer/Footer';
import { RootStyle, StyledApp } from '../../App.styled';

interface MainLayoutProps {
  children: ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <StyledApp>
      <RootStyle />
      <Header />
      {children}
      <PartnerList />
      <Carousel />
      <Footer />
    </StyledApp>
  );
};
